import { render, staticRenderFns } from "./PerformanceMainStatistic.vue?vue&type=template&id=35fe8b5b&scoped=true"
import script from "./PerformanceMainStatistic.vue?vue&type=script&lang=js"
export * from "./PerformanceMainStatistic.vue?vue&type=script&lang=js"
import style0 from "./PerformanceMainStatistic.vue?vue&type=style&index=0&id=35fe8b5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fe8b5b",
  null
  
)

export default component.exports